import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Albaran/getNumeroAlbaran`, method: 'GET'})
}
